/**
 * JSON body for material create/update. The PDF is sent as `path` (HTTPS URL after presigned upload), not base64.
 * @param {{
 *   name: string,
 *   path: string,
 *   availability: { plans: null | number[] },
 *   allow_download: boolean,
 *   banner?: string,
 * }} payload
 * @returns {Object}
 */
export function materialWriteBody(payload) {
    const body = {
        name: payload.name,
        path: payload.path,
        availability: payload.availability,
        allow_download: payload.allow_download,
    };
    if (payload.banner) {
        body.banner = payload.banner;
    }
    return body;
}
